import { GetterTree } from 'vuex'
import { RootState } from '../../state'
import { HintsState } from './state'
import { CompanyHint, CompanyHintSection } from '@/models/hints'
import { CompanyHintType } from '@/constants/hints'

export const getters: GetterTree<HintsState, RootState> = {
  getCompanyHints(state): CompanyHint[] {
    return state.list
  },

  getCompanyHintsSections: state => (
    scriptId: string,
    cardNum: number,
  ): CompanyHintSection[] => {
    return [
      {
        type: CompanyHintType.ScriptCard,
        hints: state.list.filter(hint => {
          return (
            hint.type === CompanyHintType.ScriptCard &&
            hint.script_id === scriptId &&
            hint.card_num === cardNum
          )
        }),
      },
      {
        type: CompanyHintType.Script,
        hints: state.list.filter(hint => {
          return (
            hint.type === CompanyHintType.Script && hint.script_id === scriptId
          )
        }),
      },
      {
        type: CompanyHintType.Common,
        hints: state.list.filter(hint => hint.type === CompanyHintType.Common),
      },
    ]
  },
}
